import React from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('IAvocat Error:', error, errorInfo);
    Sentry.captureException(error, {
      contexts: { react: { componentStack: errorInfo.componentStack } },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', minHeight: '100vh',
          fontFamily: "'Inter', sans-serif", backgroundColor: '#FAFAF8',
          color: '#0E1410', padding: '2rem', textAlign: 'center'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1.5rem' }}>&#9878;&#65039;</div>
          <h1 style={{
            fontFamily: "'Spectral', serif",
            fontSize: '2rem', marginBottom: '1rem', fontWeight: 600
          }}>
            Une erreur est survenue
          </h1>
          <p style={{
            fontSize: '1rem', color: '#666', marginBottom: '2rem',
            maxWidth: '500px', lineHeight: 1.6
          }}>
            L&apos;application a rencontr&eacute; un probl&egrave;me inattendu.
            Veuillez rafra&icirc;chir la page pour continuer.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 32px', backgroundColor: '#6B1F2A', color: '#fff',
              border: 'none', borderRadius: '8px', fontSize: '1rem',
              cursor: 'pointer', fontFamily: "'Inter', sans-serif",
              fontWeight: 500, transition: 'background-color 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#4A1620'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6B1F2A'}
          >
            Rafra&icirc;chir la page
          </button>
          {this.state.error && (
            <details style={{
              marginTop: '2rem', fontSize: '0.75rem', color: '#999',
              maxWidth: '600px', textAlign: 'left'
            }}>
              <summary style={{ cursor: 'pointer' }}>D&eacute;tails techniques</summary>
              <pre style={{
                marginTop: '0.5rem', padding: '0.75rem', background: '#fff',
                borderRadius: '4px', border: '1px solid #eee',
                overflow: 'auto', maxHeight: '200px', whiteSpace: 'pre-wrap'
              }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
